import { PlusIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Select from "../../../../components/select";
import { AppFile } from "../../../../models";
import { ExerciseViewModel } from "../../../../viewModels";
import { addExerciseFile } from "../actions";
import { useActionState, useEffect, useMemo } from "react";
import FormError from "../../../../components/form-error";
import Container from "../../../../components/container";
import { DecreaseExerciseFileOrderButton, DeleteAppFileButton } from "./buttons";

export default function ExerciseFilesForm({exercise,files,onReload}:{exercise:ExerciseViewModel,files:AppFile[],onReload:()=>void}){
    const initState={
      message: null,
      success: false,      
    }
    const addWithId = addExerciseFile.bind(null, exercise.id!);
    const [state, formAction, isPending] = useActionState(addWithId, initState);
    useEffect(() => {
      if (state.success && onReload) {
         onReload();
      }
    }, [state]); 

    const availableFiles = useMemo(()=>{
      return files.filter((file) => {        return !exercise.exerciseFiles?.some((ef) => ef.appFileId === file.id);
      }).map((item) => ({
                    id: item.id,
                    name: item.fileName,
                  }));
    },[files,exercise.exerciseFiles]);
    const orderNumber = useMemo(()=>{
      return       exercise.exerciseFiles?.length ? Math.max(...exercise.exerciseFiles.map(f => f.orderNumber || 0)) + 1 : 1      
    },[exercise.exerciseFiles])
    return <div>
      <h2 className="text-xl tracking-tight text-gray-900 mb-4 text-left">Exercise Files</h2>
        <form action={formAction} className="text-left">
          <input type="hidden" name="orderNumber" value={orderNumber}></input>
          
            <div className="flex flex-1 max-w-xl  flex-row gap-4">
                <Select                 
                  id="appFileId"
                  name="appFileId"
                  placeholder="Select file"                 
                  className="flex-grow"
                  items={availableFiles}
                  aria-describedby="appFileId-error"
                  required
                ></Select>
                <IconButton label="Add" icon={PlusIcon} loading={isPending}></IconButton>
            </div>
              <FormError id="appFileId-error" message={!state.success && state.message ? [state.message] : null} />
        </form>
        {/* display  exercise files*/}
          <Container className="max-w-xl   text-left">
        <table className="min-w-full text-gray-900 text-left mt-4">
          <thead className="rounded-lg text-left text-sm font-normal">
            <tr>
              <th scope="col" className="px-6 py-3">
                File Name
              </th>
             
              <th scope="col" className="px-6 py-3">
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {exercise.exerciseFiles?.map((item) => (
              <tr key={item.id}  className="border-b">
                <td className="whitespace-nowrap px-6 py-3">
                  {item.appFile?.fileName}
                </td>               
                <td className="px-6 py-4">
                  {item.id ? (
                    <div className="flex flex-1 items-center justify-end gap-2">
                      <DeleteAppFileButton id={item.id} onReload={onReload}></DeleteAppFileButton>
                      <DecreaseExerciseFileOrderButton file={item} onSuccess={onReload}></DecreaseExerciseFileOrderButton>
                      {/* <UpdateButton id={item.id} /> */}
                      {/* <DeleteButton id={item.id} /> */}
                    </div>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </Container>
    </div>
}